/* ==========================================================================
   DeusDream Academia · Curso Facebook Marketplace
   Motor del curso: landing (test + calculadora + compra) y academia
   (módulos, herramientas, examen, certificado). Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Utilidades ---------- */
  const LEVELS = [
    { name: 'Recién llegado', hint: 'Todo por descubrir.' },
    { name: 'Publicando', hint: 'Ya entendés al comprador y su deseo.' },
    { name: 'Vendedor confiable', hint: 'Perfil, títulos y fotos bajo control.' },
    { name: 'Cierra rápido', hint: 'Sabés negociar y convertir mensajes.' },
    { name: 'Vendedor Pro', hint: 'Curso completo. Ahora, a ejecutar.' }
  ];
  const THERMO_COLORS = ['#d9142f', '#f0812f', '#f2c230', '#9ccc65', '#2e9e5b'];

  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const nf0 = new Intl.NumberFormat('es-UY', { maximumFractionDigits: 0 });
  const nf1 = new Intl.NumberFormat('es-UY', { maximumFractionDigits: 1 });
  const money = (n) => (n < 0 ? '−$' : '$') + nf0.format(Math.abs(Math.round(n)));
  const pct = (n) => (Number.isFinite(n) ? nf1.format(n) : '—') + '%';
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const num = (input) => { const v = parseFloat(String(input.value).replace(',', '.')); return Number.isFinite(v) ? v : 0; };
  const normalize = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  const reduceMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const thermo = (level, labels) => {
    let html = '<div class="dd-acad-thermo" data-level="' + level + '"><span></span><span></span><span></span><span></span><span></span></div>';
    if (labels) html = '<div class="dd-acad-thermo-wrap">' + html + '<div class="dd-acad-thermo-labels">' + labels.map((l) => '<span>' + esc(l) + '</span>').join('') + '</div></div>';
    return html;
  };

  const field = (key, label, value, opts) => {
    const o = opts || {};
    const prefix = o.prefix ? '<em>' + esc(o.prefix) + '</em>' : '';
    const suffix = o.suffix ? '<em>' + esc(o.suffix) + '</em>' : '';
    const wide = o.wide ? ' dd-field--wide' : '';
    if (o.area) {
      return '<label class="dd-field' + wide + '"><span>' + esc(label) + '</span><span class="dd-field__box dd-field__box--area"><textarea data-k="' + key + '" placeholder="' + esc(o.placeholder || '') + '" rows="' + (o.rows || 3) + '">' + esc(value) + '</textarea></span></label>';
    }
    const type = o.text ? 'text' : 'number';
    const extra = o.text ? '' : ' inputmode="decimal" step="' + (o.step || 'any') + '" min="0"';
    return '<label class="dd-field' + wide + '"><span>' + esc(label) + '</span><span class="dd-field__box">' + prefix +
      '<input type="' + type + '" data-k="' + key + '" value="' + esc(value) + '" placeholder="' + esc(o.placeholder || '') + '"' + extra + (o.max ? ' maxlength="' + o.max + '"' : '') + '>' + suffix + '</span>' +
      (o.counter ? '<small class="dd-field__count" data-count="' + key + '"></small>' : '') + '</label>';
  };

  const ring = (value, color) => {
    const offset = 226 - (226 * clamp(value, 0, 100)) / 100;
    return '<div class="dd-score__ring"><svg viewBox="0 0 88 88"><circle class="bg" cx="44" cy="44" r="36"/><circle class="fg" cx="44" cy="44" r="36" style="stroke:' + color + ';stroke-dashoffset:' + offset + '"/></svg><strong>' + Math.round(value) + '</strong></div>';
  };

  const copyText = async (text, button) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
      const area = document.createElement('textarea');
      area.value = text; document.body.appendChild(area); area.select();
      try { document.execCommand('copy'); } catch (err) { /* sin acción */ }
      area.remove();
    }
    if (button) {
      const label = button.textContent;
      button.textContent = 'Copiado'; button.classList.add('is-done');
      setTimeout(() => { button.textContent = label; button.classList.remove('is-done'); }, 1500);
    }
  };

  const storage = {
    get(key, fallback) { try { const raw = window.localStorage.getItem(key); return raw ? JSON.parse(raw) : fallback; } catch (e) { return fallback; } },
    set(key, value) { try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* sin almacenamiento */ } }
  };


  /* ---------- Test de perfil (público) ---------- */
  const TEST = {
    questions: [
      { q: 'Publicaste algo y en una hora nadie escribió. ¿Qué hacés?', a: [
        ['P', 'Lo borro y lo vuelvo a hacer de cero, con mejores fotos… algún día'],
        ['R', 'Le bajo el precio para que se mueva'],
        ['F', 'Nada: me olvido hasta que alguien escriba'],
        ['I', 'No sé: no tengo idea de si alguien lo vio']] },
      { q: 'Te escriben «¿sigue disponible?» a las 22 h.', a: [
        ['F', 'Contesto mañana, o cuando me acuerde'],
        ['R', 'Contesto «sí» y ya ofrezco un descuento'],
        ['P', 'Pienso la respuesta perfecta y tardo una hora'],
        ['I', 'Contesto «sí» y espero']] },
      { q: 'Te ofrecen 30% menos de lo publicado.', a: [
        ['R', 'Acepto: prefiero vender'],
        ['F', 'Dejo el mensaje en visto'],
        ['P', 'Me ofendo y respondo largo explicando el valor'],
        ['I', 'Respondo «no» y listo']] },
      { q: '¿Qué te frena más?', a: [
        ['P', 'Que la publicación no quede perfecta'],
        ['R', 'Que no me elijan'],
        ['F', 'No tener tiempo para contestar'],
        ['I', 'No entender por qué no me ven']] },
      { q: 'Tus fotos hoy son…', a: [
        ['I', 'Las que saqué rápido o las de internet'],
        ['P', 'Pocas, porque todavía no saqué las buenas'],
        ['R', 'Normales: compito con el precio'],
        ['F', 'Buenas, pero tengo publicaciones viejas que nunca toqué']] },
      { q: 'Un comprador desaparece después de coordinar.', a: [
        ['F', 'Lo dejo pasar y no aviso a nadie más'],
        ['R', 'Le escribo ofreciéndole un descuento para que vuelva'],
        ['P', 'Me quedo pensando qué hice mal'],
        ['I', 'No tenía a nadie más interesado']] }
    ],
    results: {
      P: { name: 'El Perfeccionista', text: 'Tu exigencia te protege de la crítica, pero también de vender. Lo que no publicás no puede fallar… ni venderse. Detrás del «todavía no está listo» suele haber miedo a la mirada del otro.', fix: 'Publicar al 80% y mejorar con los mensajes que llegan, no con suposiciones.', win: 'Esta semana: publicá 3 productos con fotos propias de hoy. Mejoralos después.', mods: [2, 5, 10] },
      R: { name: 'El Regalador', text: 'Bajás el precio para no ser rechazado. Vendés, pero el miedo se lleva tu margen. Y un precio que cede sin pelear se lee como inseguridad, no como generosidad.', fix: 'Precio a publicar, objetivo y piso decididos de antemano. Concesiones que se achican.', win: 'Hoy: pasá tus 5 productos principales por la calculadora de precio y regateo.', mods: [7, 1, 8] },
      F: { name: 'El Fantasma', text: 'Tenés publicaciones, pero no estás. Respondés tarde o con un «sí», y el comprador ya le compró a otro. No es falta de interés: es que la venta todavía no tiene un lugar en tu rutina.', fix: 'Respuestas listas para pegar, ritmo diario y notificaciones activas.', win: 'Hoy: guardá las 6 plantillas y respondé todo en menos de 15 minutos.', mods: [8, 3, 10] },
      I: { name: 'El Invisible', text: 'Hacés el trabajo, pero no te encuentran. No es mala suerte: casi siempre es título, portada, ubicación o categoría mal cargadas.', fix: 'Títulos con la fórmula, portadas que se entienden en miniatura y todos los campos completos.', win: 'Hoy: reescribí el título y la portada de tus 3 publicaciones principales.', mods: [4, 5, 3] }
    }
  };

  const MODULE_NAMES = {
    1: 'El comprador de Marketplace', 2: 'Tu perfil vende primero', 3: 'Cómo te muestra Marketplace', 4: 'Títulos',
    5: 'Fotos', 6: 'Descripción', 7: 'Precio y regateo', 8: 'Messenger', 9: 'Entregas y estafas', 10: 'Escalar y plan de 30 días'
  };

  /* ==========================================================================
     HERRAMIENTAS
     ========================================================================== */
  const TOOLS = {};
  const TOOL_META = {
    priceCalc: { icon: '$', name: 'Precio y regateo' },
    bargainCalc: { icon: '⇄', name: 'Simulador de regateo' },
    titleLab: { icon: 'T', name: 'Laboratorio de títulos' },
    coverCheck: { icon: '▣', name: 'Checklist de fotos' },
    descGen: { icon: '¶', name: 'Generador de descripción' },
    answerSim: { icon: '✉', name: 'Simulador de Messenger' },
    fearSort: { icon: '?', name: 'Detector de miedos' },
    scamCheck: { icon: '!', name: 'Detector de estafas' },
    rhythmCalc: { icon: '↻', name: 'Ritmo de publicación' },
    boostCalc: { icon: '↗', name: '¿Promocionar o no?' },
    plan30: { icon: '✓', name: 'Plan de 30 días' },
    sellerTest: { icon: '◎', name: 'Test de perfil vendedor' }
  };

  const toolHead = (title, sub) => '<div class="dd-tool__head"><span class="dd-tool__badge">Herramienta</span><h3>' + esc(title) + '</h3><p>' + esc(sub) + '</p></div>';

  const bindInputs = (host, onChange, ctx) => {
    let used = false;
    host.addEventListener('input', () => {
      onChange();
      if (!used && ctx && ctx.used) { used = true; ctx.used(); }
    });
    host.addEventListener('change', () => onChange());
    onChange();
  };

  /* 1 · Calculadora de ganancia y precio a publicar */
  TOOLS.priceCalc = (host, ctx) => {
    const c = ctx.cfg;
    host.innerHTML = toolHead('Calculadora de precio y regateo', 'Cuánto publicar para cobrar lo que querés, y cuánto te queda.') +
      '<div class="dd-tool__grid"><div class="dd-tool__inputs">' +
      field('cost', 'Costo del producto', 600, { prefix: '$' }) +
      field('want', 'Precio que querés cobrar', 1290, { prefix: '$' }) +
      field('room', 'Espacio para regatear', 10, { suffix: '%', step: 0.5 }) +
      field('deliv', 'Entrega que pagás vos', c.delivery, { prefix: '$' }) +
      field('payfee', 'Comisión del medio de pago', c.payFee, { suffix: '%', step: 0.1 }) +
      field('other', 'Empaque y otros', c.packaging, { prefix: '$' }) +
      field('target', 'Margen mínimo aceptable', 15, { suffix: '%', wide: true }) +
      '</div><div class="dd-out" aria-live="polite" data-out></div></div>' +
      '<p class="dd-tool__note">Publicar en Marketplace no tiene comisión para particulares. Si cobrás con un link de pago, poné su comisión real. Los valores iniciales son de ejemplo.</p>';
    const get = (k) => host.querySelector('[data-k="' + k + '"]');
    const out = host.querySelector('[data-out]');
    const round50 = (n) => Math.ceil(n / 50) * 50;
    const render = () => {
      const cost = num(get('cost')), want = num(get('want')), room = num(get('room')) / 100;
      const deliv = num(get('deliv')), fee = num(get('payfee')) / 100, other = num(get('other')), target = num(get('target')) / 100;
      const publish = room < 1 ? round50(want / (1 - room)) : want;
      const profitAt = (p) => p - p * fee - cost - deliv - other;
      const profitWant = profitAt(want);
      const profitPublish = profitAt(publish);
      const margin = want > 0 ? (profitWant / want) * 100 : 0;
      const F = cost + deliv + other;
      const breakEven = 1 - fee > 0 ? F / (1 - fee) : Infinity;
      const floorDen = 1 - fee - target;
      const floor = floorDen > 0 ? round50(F / floorDen) : Infinity;
      let lvl, msg;
      if (profitWant < 0) { lvl = 0; msg = 'Al precio que querés cobrar, perdés plata.'; }
      else if (margin < 8) { lvl = 1; msg = 'Margen muy finito: un regateo y quedás en cero.'; }
      else if (margin < 15) { lvl = 2; msg = 'Justo. Cuidá mucho el piso.'; }
      else if (margin < 25) { lvl = 3; msg = 'Margen sano para negociar.'; }
      else { lvl = 4; msg = 'Excelente: tenés espacio para packs y extras.'; }
      out.innerHTML =
        '<div class="dd-out__verdict">' + thermo(lvl) + '<b>' + esc(msg) + '</b></div>' +
        '<div class="dd-out__big"><small>Precio para publicar</small><strong>' + money(publish) + '</strong></div>' +
        '<ul class="dd-rows">' +
        '<li><span>Si te pagan lo publicado</span><b>' + money(profitPublish) + '</b></li>' +
        '<li><span>Si cerrás en lo que querías</span><b>' + money(profitWant) + '</b></li>' +
        '<li class="is-total"><span>Tu piso (margen mínimo)</span><b>' + (Number.isFinite(floor) ? money(floor) : '—') + '</b></li></ul>' +
        '<div class="dd-kpis">' +
        '<div class="dd-kpi"><small>Margen al precio objetivo</small><strong>' + pct(margin) + '</strong></div>' +
        '<div class="dd-kpi"><small>Precio para no perder</small><strong>' + (Number.isFinite(breakEven) ? money(Math.ceil(breakEven)) : '—') + '</strong></div>' +
        '</div>';
    };
    bindInputs(host, render, ctx);
  };

  /* 2 · Simulador de regateo */
  TOOLS.bargainCalc = (host, ctx) => {
    host.innerHTML = toolHead('Simulador de regateo', 'Tu contraoferta, paso a paso, sin bajar de tu piso.') +
      '<div class="dd-tool__grid"><div class="dd-tool__inputs">' +
      field('pub', 'Precio publicado', 1400, { prefix: '$' }) +
      field('floor', 'Tu piso', 1250, { prefix: '$' }) +
      field('offer', 'Oferta del comprador', 1000, { prefix: '$', wide: true }) +
      '</div><div class="dd-out" aria-live="polite" data-out></div></div>';
    const get = (k) => host.querySelector('[data-k="' + k + '"]');
    const out = host.querySelector('[data-out]');
    const r10 = (n) => Math.round(n / 10) * 10;
    const render = () => {
      const pub = num(get('pub')), floor = Math.min(num(get('floor')), pub), offer = num(get('offer'));
      if (pub <= 0) { out.innerHTML = '<p class="dd-tool__note">Cargá el precio publicado.</p>'; return; }
      if (offer >= pub) {
        out.innerHTML = '<div class="dd-out__verdict">' + thermo(4) + '<b>¡Cerrá ya! Te ofrecen lo publicado.</b></div><div class="dd-why"><b>Respuesta</b>«¡Perfecto! Te lo reservo. ¿Te queda mejor hoy o mañana?»</div>';
        return;
      }
      if (offer >= floor) {
        const meet = r10(Math.max(offer, (offer + pub) / 2));
        out.innerHTML = '<div class="dd-out__verdict">' + thermo(3) + '<b>La oferta está arriba de tu piso.</b></div>' +
          '<div class="dd-out__big"><small>Contraoferta sugerida</small><strong>' + money(meet) + '</strong></div>' +
          '<div class="dd-why"><b>Respuesta</b>«¡Hola! Te lo dejo en ' + money(meet) + ' si lo retirás hoy. ¿Te lo reservo?» Si insiste, aceptá su oferta pidiendo algo a cambio.</div>';
        return;
      }
      const gap = pub - floor;
      const step1 = r10(pub - gap * 0.45);
      const step2 = r10(pub - gap * 0.8);
      const lowball = (pub - offer) / pub;
      const lvl = lowball > 0.35 ? 0 : lowball > 0.25 ? 1 : 2;
      const msg = lowball > 0.35 ? 'Oferta muy baja: tanteo. No bajes de golpe.' : lowball > 0.25 ? 'Oferta baja: contraofertá cerca de tu precio.' : 'Oferta razonable: hay acuerdo posible.';
      out.innerHTML = '<div class="dd-out__verdict">' + thermo(lvl) + '<b>' + esc(msg) + '</b></div>' +
        '<ul class="dd-rows">' +
        '<li><span>1.ª contraoferta</span><b>' + money(step1) + '</b></li>' +
        '<li><span>2.ª, si insiste</span><b>' + money(step2) + '</b></li>' +
        '<li class="is-total"><span>Última: tu piso, con condición</span><b>' + money(floor) + '</b></li></ul>' +
        '<div class="dd-why"><b>Primera respuesta</b>«¡Hola! Gracias por la oferta. Lo más que puedo hacer es ' + money(step1) + ' si lo retirás hoy. ¿Te lo reservo?»</div>' +
        '<p class="dd-tool__note">Cada concesión es más chica que la anterior: así el comprador siente que llegó al límite. En la última, pedí algo a cambio: retiro hoy, pago en efectivo o que lleve dos.</p>';
    };
    bindInputs(host, render, ctx);
  };

  /* 3 · Ritmo de publicación */
  TOOLS.rhythmCalc = (host, ctx) => {
    host.innerHTML = toolHead('Ritmo de publicación', 'Cuántas publicaciones nuevas o renovadas por día para mantenerte fresco.') +
      '<div class="dd-tool__grid"><div class="dd-tool__inputs">' +
      field('active', 'Publicaciones activas', 30, { suffix: 'pub.' }) +
      field('newWeek', 'Productos nuevos por semana', 5, { suffix: 'pub.' }) +
      field('cycle', 'Cada cuántos días renovar', 7, { suffix: 'días' }) +
      field('mins', 'Minutos por publicación', 4, { suffix: 'min' }) +
      '</div><div class="dd-out" aria-live="polite" data-out></div></div>' +
      '<p class="dd-tool__note">Renová solo cuando Marketplace te ofrezca la opción. Probá publicar al mediodía y de noche, cuando más gente hace scroll, y medí qué horario te trae más mensajes.</p>';
    const get = (k) => host.querySelector('[data-k="' + k + '"]');
    const out = host.querySelector('[data-out]');
    const render = () => {
      const active = num(get('active')), nw = num(get('newWeek')), cycle = Math.max(1, num(get('cycle'))), mins = num(get('mins'));
      const renewDay = Math.ceil(active / cycle);
      const newDay = Math.ceil(nw / 7);
      const perDay = renewDay + newDay;
      const time = perDay * mins;
      const lvl = perDay === 0 ? 0 : perDay <= 2 ? 2 : perDay <= 8 ? 4 : perDay <= 15 ? 3 : 1;
      const msg = perDay === 0 ? 'Sin movimiento, tu catálogo se apaga.' : perDay > 15 ? 'Mucho para hacer a mano: priorizá lo que más vende.' : 'Un ritmo sostenible: hacelo todos los días.';
      out.innerHTML = '<div class="dd-out__verdict">' + thermo(lvl) + '<b>' + esc(msg) + '</b></div>' +
        '<div class="dd-out__big"><small>Publicaciones frescas por día</small><strong>' + perDay + '</strong></div>' +
        '<div class="dd-kpis"><div class="dd-kpi"><small>Renovar por día</small><strong>' + renewDay + '</strong></div>' +
        '<div class="dd-kpi"><small>Nuevas por día</small><strong>' + newDay + '</strong></div>' +
        '<div class="dd-kpi"><small>Tiempo diario</small><strong>' + nf0.format(time) + ' min</strong></div>' +
        '<div class="dd-kpi"><small>Frescas por semana</small><strong>' + perDay * 7 + '</strong></div></div>';
    };
    bindInputs(host, render, ctx);
  };

  /* 4 · Laboratorio de títulos */
  const FORBIDDEN = ['lea descripcion', 'leer descripcion', 'inbox', 'consultar', 'urgente', 'barato', 'imperdible', 'oferta', 'impecable', 'hermoso', 'hermosa', 'liquido', 'remato', 'md', 'privado', 'whatsapp'];
  TOOLS.titleLab = (host, ctx) => {
    host.innerHTML = toolHead('Laboratorio de títulos', 'Producto + Marca + Modelo + Dato clave + Estado. Te puntúa en vivo.') +
      '<div class="dd-tool__grid"><div class="dd-tool__inputs">' +
      field('prod', 'Producto', 'Auriculares inalámbricos', { text: true }) +
      field('brand', 'Marca', 'JBL', { text: true }) +
      field('model', 'Modelo', 'Tune 520BT', { text: true }) +
      field('feat', 'Dato clave', 'Bluetooth', { text: true }) +
      field('state', 'Estado', 'nuevos', { text: true, wide: true }) +
      field('title', 'Tu título', '¡¡IMPERDIBLE!! Auris JBL lea descripción', { text: true, wide: true, counter: true, max: 100 }) +
      '<div class="dd-suggest dd-field--wide" data-suggest></div>' +
      '</div><div class="dd-out" aria-live="polite" data-out></div></div>';
    const get = (k) => host.querySelector('[data-k="' + k + '"]');
    const out = host.querySelector('[data-out]');
    const suggestBox = host.querySelector('[data-suggest]');
    const counter = host.querySelector('[data-count="title"]');
    const tidy = (s) => s.trim().replace(/\s+/g, ' ');
    const suggestion = () => {
      let s = ['prod', 'brand', 'model', 'feat', 'state'].map((k) => tidy(get(k).value)).filter(Boolean).join(' ');
      s = s.charAt(0).toUpperCase() + s.slice(1);
      if (s.length > 65) s = s.slice(0, 65).replace(/\s+\S*$/, '');
      return s;
    };
    host.addEventListener('click', (event) => {
      if (event.target.closest('[data-use-suggest]')) {
        get('title').value = suggestion();
        get('title').dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    const render = () => {
      const raw = get('title').value;
      const t = normalize(raw);
      const checks = [];
      let score = 100;
      const add = (state, text) => { checks.push([state, text]); if (state === 'bad') score -= 20; if (state === 'warn') score -= 9; };
      const len = raw.trim().length;
      counter.textContent = len + ' / 65';
      counter.classList.toggle('is-over', len > 65);
      if (!len) add('bad', 'Escribí un título para analizarlo.');
      else if (len > 65) add('warn', 'Tiene ' + len + ' caracteres: en el celular se corta. Lo clave, primero.');
      else if (len < 22) add('warn', 'Es corto: te faltan palabras que la gente busca.');
      else add('ok', 'Buen largo: ' + len + ' caracteres.');
      [['prod', 'el producto'], ['brand', 'la marca'], ['model', 'el modelo'], ['feat', 'el dato clave'], ['state', 'el estado']].forEach(([k, label]) => {
        const words = normalize(get(k).value).split(/\s+/).filter((w) => w.length > 1);
        if (!words.length) return;
        const hit = words.filter((w) => t.includes(w)).length / words.length;
        if (hit >= 0.99) add('ok', 'Incluye ' + label + '.');
        else if (hit > 0) add('warn', 'Incluye ' + label + ' a medias.');
        else add(k === 'state' || k === 'feat' ? 'warn' : 'bad', 'Falta ' + label + ': «' + get(k).value.trim() + '».');
      });
      const first = normalize(get('prod').value).split(/\s+/)[0];
      if (first && len) {
        if (t.replace(/^[^a-z0-9]+/, '').startsWith(first)) add('ok', 'Empieza por el producto: se entiende en la miniatura.');
        else add('warn', 'Empezá por el producto: es lo que se ve primero en la grilla.');
      }
      const clean = ' ' + t.replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ') + ' ';
      const bad = FORBIDDEN.filter((w) => clean.includes(' ' + w + ' '));
      if (bad.length) add('bad', 'Sacá: «' + bad.join('», «') + '». No lo busca nadie y resta confianza.');
      const emojis = (raw.match(/\p{Extended_Pictographic}/gu) || []).length;
      if (/[!¡*★☆|]{2,}/.test(raw) || emojis > 1) add('bad', 'Signos repetidos o emojis de más: se lee como spam.');
      const letters = raw.replace(/[^A-Za-zÁÉÍÓÚÑáéíóúñ]/g, '');
      const upper = raw.replace(/[^A-ZÁÉÍÓÚÑ]/g, '').length;
      if (letters.length > 8 && upper / letters.length > 0.5) add('warn', 'Demasiadas MAYÚSCULAS: se lee como grito.');
      score = clamp(score, 0, 100);
      const lvl = score >= 90 ? 4 : score >= 75 ? 3 : score >= 55 ? 2 : score >= 35 ? 1 : 0;
      const verdict = ['Este título no aparece ni convence.', 'Necesita trabajo.', 'Va mejorando.', 'Buen título.', 'Título que aparece y se entiende.'][lvl];
      out.innerHTML = '<div class="dd-score">' + ring(score, THERMO_COLORS[lvl]) + '<div class="dd-score__text"><b>' + verdict + '</b><span>Puntaje según la fórmula y las buenas prácticas.</span></div></div>' +
        '<ul class="dd-checklist">' + checks.map(([s, txt]) => '<li class="is-' + s + '"><i>' + (s === 'ok' ? '✓' : s === 'warn' ? '!' : '×') + '</i><span>' + esc(txt) + '</span></li>').join('') + '</ul>';
      const sug = suggestion();
      suggestBox.innerHTML = sug ? '<span>Sugerido: <b>' + esc(sug) + '</b></span><button type="button" class="dd-copy" data-use-suggest>Usar</button>' : '<span>Completá los campos para ver una sugerencia.</span>';
    };
    bindInputs(host, render, ctx);
  };

  /* 5 · Checklist de fotos */
  TOOLS.coverCheck = (host, ctx) => {
    const items = [
      'La portada se entiende en miniatura (prueba del brazo estirado)',
      'Producto grande y centrado, fondo limpio que contrasta',
      'Luz natural, sin sombras duras',
      'Fotos propias, nada bajado de internet',
      'Una foto con escena: el producto en uso, en un lugar real',
      'Foto de escala: en la mano o al lado de algo conocido',
      'Detalle de etiqueta, modelo o materiales',
      'Si es usado: los detalles y defectos a la vista',
      'Uso casi todas las fotos que permite la publicación'
    ];
    host.innerHTML = toolHead('Checklist de fotos', 'Marcá lo que tu publicación ya cumple.') +
      '<div class="dd-tool__grid"><ul class="dd-toggles">' + items.map((it, i) => '<li><label><input type="checkbox" data-i="' + i + '"><i></i><span>' + esc(it) + '</span></label></li>').join('') + '</ul>' +
      '<div class="dd-out" aria-live="polite" data-out></div></div>';
    const out = host.querySelector('[data-out]');
    const render = () => {
      const n = host.querySelectorAll('input:checked').length;
      const score = Math.round((n / items.length) * 100);
      const lvl = n === items.length ? 4 : n >= 7 ? 3 : n >= 5 ? 2 : n >= 2 ? 1 : 0;
      const msg = ['Tus fotos no frenan el scroll.', 'Hay mucho para mejorar.', 'A mitad de camino.', 'Muy bien, casi lista.', 'Fotos que frenan el dedo y dan confianza.'][lvl];
      out.innerHTML = '<div class="dd-score">' + ring(score, THERMO_COLORS[lvl]) + '<div class="dd-score__text"><b>' + msg + '</b><span>' + n + ' de ' + items.length + ' criterios.</span></div></div>' + thermo(lvl) +
        '<p class="dd-tool__note">Tip: portada limpia para ganar el clic, y escena en las fotos siguientes para despertar el deseo.</p>';
    };
    bindInputs(host, render, ctx);
  };

  /* 6 · Generador de descripción */
  TOOLS.descGen = (host, ctx) => {
    host.innerHTML = toolHead('Generador de descripción', 'Contesta antes de que pregunten y filtra a los curiosos.') +
      '<div class="dd-tool__grid"><div class="dd-tool__inputs dd-tool__inputs--one">' +
      field('prod', 'Qué es y para quién', 'Auriculares inalámbricos JBL Tune 520BT, ideales para el trabajo y el gimnasio.', { area: true, rows: 2 }) +
      field('state', 'Estado', 'Nuevos, en caja sellada.', { text: true }) +
      field('includes', 'Qué incluye (uno por línea)', 'Auriculares\nCable USB-C\nManual', { area: true }) +
      field('specs', 'Medidas o compatibilidad (una por línea)', 'Android y iPhone\nBluetooth 5.3\nHasta 57 h de batería', { area: true }) +
      field('deliv', 'Entrega', 'Entrego en Tres Cruces de lunes a viernes de 10 a 19 h. Envío por cadete a cargo del comprador.', { area: true, rows: 2 }) +
      field('pay', 'Pago', 'Efectivo o transferencia (se entrega con la transferencia acreditada).', { text: true }) +
      field('price', 'Precio', 'Precio conversable.', { text: true }) +
      field('kw', 'Sinónimos que la gente busca', 'auriculares bluetooth, audífonos, cascos inalámbricos', { text: true }) +
      '</div><div class="dd-out dd-copybox" data-out><pre data-pre></pre><div data-warn></div><button type="button" class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--sm" data-copy-desc>Copiar descripción</button></div></div>';
    const get = (k) => host.querySelector('[data-k="' + k + '"]');
    const pre = host.querySelector('[data-pre]');
    const warn = host.querySelector('[data-warn]');
    const lines = (v) => String(v).split(/\n/).map((s) => s.trim()).filter(Boolean);
    const val = (k) => get(k).value.trim();
    const build = () => {
      const parts = [];
      const head = [val('prod'), val('state')].filter(Boolean).join(' ');
      if (head) parts.push(head);
      const inc = lines(get('includes').value);
      if (inc.length) parts.push('Incluye:\n' + inc.map((l) => '• ' + l).join('\n'));
      const sp = lines(get('specs').value);
      if (sp.length) parts.push('Detalles:\n' + sp.map((l) => '• ' + l).join('\n'));
      const cond = [val('deliv') && '📍 ' + val('deliv'), val('pay') && '💳 ' + val('pay'), val('price') && '💬 ' + val('price')].filter(Boolean);
      if (cond.length) parts.push(cond.join('\n'));
      parts.push('Si la publicación está activa, está disponible.');
      if (val('kw')) parts.push('Búsquedas: ' + val('kw'));
      return parts.join('\n\n');
    };
    const render = () => {
      const text = build();
      pre.textContent = text;
      const tips = [];
      if (!val('deliv')) tips.push('Falta la entrega: es la pregunta número uno.');
      if (!val('pay')) tips.push('Falta la forma de pago: baja el miedo a la estafa.');
      if (/lea|leer|inbox|consult/i.test(text)) tips.push('Sacá «lea», «inbox» o «consultar»: decí las cosas directamente.');
      warn.innerHTML = tips.length ? '<div class="dd-why"><b>Ojo</b>' + tips.map(esc).join('<br>') + '</div>' : '';
    };
    host.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-copy-desc]');
      if (btn) copyText(pre.textContent, btn);
    });
    bindInputs(host, render, ctx);
  };

  /* 7 · Detector de miedos (datos del contenido) */
  TOOLS.fearSort = (host, ctx) => {
    const data = ctx.content && ctx.content.fears;
    if (!data) { host.innerHTML = ''; return; }
    const title = data.title || 'Detector de miedos';
    let i = 0, right = 0;
    const draw = () => {
      if (i >= data.items.length) {
        const lvl = right === data.items.length ? 4 : right >= data.items.length - 1 ? 3 : right >= 3 ? 2 : 1;
        host.innerHTML = toolHead(title, 'Resultado') +
          '<div class="dd-result"><div class="dd-score">' + ring((right / data.items.length) * 100, THERMO_COLORS[lvl]) + '<div class="dd-score__text"><b>' + right + ' de ' + data.items.length + ' detectados</b><span>' + esc(data.resultHint || '') + '</span></div></div>' +
          '<div class="dd-result__box"><b>Cómo calmar cada miedo antes de que escriban</b>' + data.cats.map((c) => '<p><strong>' + esc(c.label) + '</strong> ' + esc(c.fix) + '</p>').join('') + '</div>' +
          '<div class="dd-result__actions"><button type="button" class="dd-linkbtn" data-restart>Repetir</button></div></div>';
        if (ctx.used) ctx.used();
        return;
      }
      const item = data.items[i];
      host.innerHTML = toolHead(title, data.subtitle || '') +
        '<div class="dd-progress"><span>' + (i + 1) + ' / ' + data.items.length + '</span><div class="dd-progress__bar"><i style="width:' + ((i / data.items.length) * 100) + '%"></i></div></div>' +
        '<div class="dd-bubble"><small>' + esc(data.intro || 'Mensaje') + '</small>«' + esc(item.q) + '»</div>' +
        '<div class="dd-chips" style="margin-top:18px">' + data.cats.map((c) => '<button type="button" class="dd-chip" data-cat="' + esc(c.id) + '">' + esc(c.label) + '</button>').join('') + '</div><div data-fb></div>';
    };
    host.addEventListener('click', (event) => {
      if (event.target.closest('[data-restart]')) { i = 0; right = 0; draw(); return; }
      if (event.target.closest('[data-next-fear]')) { i += 1; draw(); return; }
      const chip = event.target.closest('[data-cat]');
      if (!chip || chip.disabled) return;
      const item = data.items[i];
      const ok = chip.dataset.cat === item.cat;
      if (ok) right += 1;
      host.querySelectorAll('[data-cat]').forEach((b) => {
        b.disabled = true;
        if (b.dataset.cat === item.cat) b.classList.add('is-right');
        else if (b === chip) b.classList.add('is-wrong');
      });
      const cat = data.cats.find((c) => c.id === item.cat);
      host.querySelector('[data-fb]').innerHTML = '<div class="dd-why"><b>' + (ok ? '¡Exacto!' : 'Casi.') + ' Es «' + esc(cat.label) + '»</b>' + esc(cat.fix) + '</div>' +
        '<button type="button" class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--sm" style="margin-top:14px" data-next-fear>' + (i + 1 < data.items.length ? 'Siguiente' : 'Ver resultado') + '</button>';
    });
    draw();
  };

  /* 8 · Simulador de Messenger */
  TOOLS.answerSim = (host, ctx) => {
    const data = ctx.content && ctx.content.answers;
    const templates = (ctx.content && ctx.content.templates) || [];
    if (!data) { host.innerHTML = ''; return; }
    let i = 0, right = 0;
    const templatesHtml = '<ul class="dd-templates">' + templates.map((t, k) => '<li><div><b>' + esc(t.label) + '</b><button type="button" class="dd-copy" data-copy-tpl="' + k + '">Copiar</button></div><p>' + esc(t.text) + '</p></li>').join('') + '</ul>';
    const draw = () => {
      if (i >= data.length) {
        host.innerHTML = toolHead('Simulador de Messenger', right + ' de ' + data.length + ' respuestas que cierran') +
          '<div class="dd-result"><p>Tus plantillas. Copialas, completá los corchetes con tus datos y tenelas a mano para responder en segundos.</p>' + templatesHtml +
          '<div class="dd-result__actions"><button type="button" class="dd-linkbtn" data-restart>Repetir el simulador</button></div></div>';
        if (ctx.used) ctx.used();
        return;
      }
      const s = data[i];
      host.innerHTML = toolHead('Simulador de Messenger', 'Elegí la respuesta que lleva a la venta.') +
        '<div class="dd-progress"><span>' + (i + 1) + ' / ' + data.length + '</span><div class="dd-progress__bar"><i style="width:' + ((i / data.length) * 100) + '%"></i></div></div>' +
        '<div class="dd-bubble"><small>Te escriben por Messenger</small>«' + esc(s.q) + '»</div>' +
        '<div class="dd-options">' + s.options.map((o, k) => '<button type="button" class="dd-option" data-opt="' + k + '"><span>' + esc(o.t) + '</span></button>').join('') + '</div><div data-fb></div>';
    };
    host.addEventListener('click', (event) => {
      const tpl = event.target.closest('[data-copy-tpl]');
      if (tpl) { copyText(templates[Number(tpl.dataset.copyTpl)].text, tpl); return; }
      if (event.target.closest('[data-restart]')) { i = 0; right = 0; draw(); return; }
      if (event.target.closest('[data-next-ans]')) { i += 1; draw(); return; }
      const btn = event.target.closest('[data-opt]');
      if (!btn || btn.disabled) return;
      const s = data[i];
      const pick = Number(btn.dataset.opt);
      if (pick === s.best) right += 1;
      host.querySelectorAll('[data-opt]').forEach((b) => {
        const k = Number(b.dataset.opt);
        b.disabled = true;
        b.insertAdjacentHTML('beforeend', '<small>' + esc(s.options[k].fb) + '</small>');
        if (k === s.best) b.classList.add('is-right');
        else if (k === pick) b.classList.add('is-wrong');
        else b.classList.add('is-dim');
      });
      host.querySelector('[data-fb]').innerHTML = '<button type="button" class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--sm" style="margin-top:16px" data-next-ans>' + (i + 1 < data.length ? 'Siguiente mensaje' : 'Ver mis plantillas') + '</button>';
    });
    draw();
  };

  /* 9 · Detector de estafas */
  TOOLS.scamCheck = (host, ctx) => {
    const flags = [
      ['Te pide un código que te llegó por SMS o WhatsApp', 5],
      ['Manda una captura y apura para que despaches', 4],
      ['Quiere pagar de más y que le devuelvas la diferencia', 5],
      ['Te manda un link para «cobrar» o «liberar el pago»', 5],
      ['Dice ser soporte de Facebook o del banco', 5],
      ['Perfil nuevo, sin foto o sin amigos', 2],
      ['No pregunta nada del producto, solo apura', 2],
      ['Quiere mandar a «un cadete» o pagar por adelantado un envío raro', 3],
      ['Te pide pasar a otra app enseguida, sin motivo', 1]
    ];
    host.innerHTML = toolHead('Detector de estafas', 'Marcá lo que está pasando en la conversación.') +
      '<div class="dd-tool__grid"><ul class="dd-toggles">' + flags.map((f, i) => '<li><label><input type="checkbox" data-i="' + i + '"><i></i><span>' + esc(f[0]) + '</span></label></li>').join('') + '</ul>' +
      '<div class="dd-out" aria-live="polite" data-out></div></div>';
    const out = host.querySelector('[data-out]');
    const render = () => {
      let risk = 0, critical = false;
      host.querySelectorAll('input:checked').forEach((b) => { const w = flags[Number(b.dataset.i)][1]; risk += w; if (w >= 5) critical = true; });
      let lvl, msg, tip;
      if (critical || risk >= 6) { lvl = 0; msg = 'Estafa casi segura. Cortá la conversación.'; tip = 'No compartas códigos, no abras links y no despaches. Denunciá el perfil desde Marketplace.'; }
      else if (risk >= 3) { lvl = 1; msg = 'Señales de riesgo. Frená y verificá.'; tip = 'Pedí pago contra entrega en tu punto fijo o esperá la acreditación en tu app del banco.'; }
      else if (risk > 0) { lvl = 3; msg = 'Atención, pero puede ser un comprador real.'; tip = 'Seguí tus reglas de siempre: punto fijo y plata acreditada antes de entregar.'; }
      else { lvl = 4; msg = 'Sin señales de alarma.'; tip = 'Igual: la mercadería sale cuando la plata entró.'; }
      out.innerHTML = '<div class="dd-out__verdict">' + thermo(lvl, ['Estafa', 'Riesgo', 'Dudoso', 'Atención', 'Seguro']) + '<b>' + esc(msg) + '</b></div><div class="dd-why"><b>Qué hacer</b>' + esc(tip) + '</div>';
    };
    bindInputs(host, render, ctx);
  };

  /* 10 · Promocionar o no */
  TOOLS.boostCalc = (host, ctx) => {
    host.innerHTML = toolHead('¿Promocionar o no?', 'Cuánto podés pagar por mensaje sin perder plata.') +
      '<div class="dd-tool__grid"><div class="dd-tool__inputs">' +
      field('budget', 'Presupuesto total', 600, { prefix: '$' }) +
      field('msgs', 'Mensajes que trajo', 20, { suffix: 'msj.' }) +
      field('conv', 'De cada 100 mensajes, ¿cuántos compran?', 15, { suffix: '%', step: 0.5 }) +
      field('profit', 'Ganancia por venta', 300, { prefix: '$' }) +
      '</div><div class="dd-out" aria-live="polite" data-out></div></div>' +
      '<p class="dd-tool__note">Medí tu conversión con mensajes orgánicos antes de pagar. Empezá con un presupuesto chico y una sola publicación que ya funcione.</p>';
    const get = (k) => host.querySelector('[data-k="' + k + '"]');
    const out = host.querySelector('[data-out]');
    const render = () => {
      const budget = num(get('budget')), msgs = num(get('msgs')), conv = num(get('conv')) / 100, profit = num(get('profit'));
      const cpm = msgs > 0 ? budget / msgs : Infinity;
      const maxCpm = profit * conv;
      const sales = msgs * conv;
      const result = sales * profit - budget;
      const r = maxCpm > 0 && Number.isFinite(cpm) ? cpm / maxCpm : 2;
      const lvl = r <= 0.5 ? 4 : r <= 0.8 ? 3 : r <= 1 ? 2 : r <= 1.3 ? 1 : 0;
      const msg = ['La promoción te hace perder plata.', 'Por encima del equilibrio: perdés.', 'Al límite: casi no ganás.', 'Rentable.', 'Muy rentable: podés subir el presupuesto de a poco.'][lvl];
      out.innerHTML = '<div class="dd-out__verdict">' + thermo(lvl) + '<b>' + msg + '</b></div>' +
        '<div class="dd-kpis"><div class="dd-kpi"><small>Costo por mensaje</small><strong>' + (Number.isFinite(cpm) ? money(cpm) : '—') + '</strong></div>' +
        '<div class="dd-kpi"><small>Máximo por mensaje</small><strong>' + money(maxCpm) + '</strong></div>' +
        '<div class="dd-kpi"><small>Ventas estimadas</small><strong>' + nf1.format(sales) + '</strong></div>' +
        '<div class="dd-kpi"><small>Costo por venta</small><strong>' + (sales > 0 ? money(budget / sales) : '—') + '</strong></div></div>' +
        '<div class="dd-out__big"><small>Resultado de la promoción</small><strong class="' + (result < 0 ? 'is-neg' : '') + '">' + money(result) + '</strong></div>';
    };
    bindInputs(host, render, ctx);
  };

  /* 11 · Plan de 30 días */
  TOOLS.plan30 = (host, ctx) => {
    const plan = ctx.content && ctx.content.plan;
    if (!plan) { host.innerHTML = ''; return; }
    const state = ctx.store ? ctx.store.data.plan : {};
    const total = plan.reduce((acc, w) => acc + w.items.length, 0);
    const draw = () => {
      const done = Object.keys(state).filter((k) => state[k]).length;
      host.innerHTML = toolHead('Plan de 30 días', done + ' de ' + total + ' acciones completadas. Se guarda solo.') +
        '<div class="dd-progress"><span>' + Math.round((done / total) * 100) + '%</span><div class="dd-progress__bar"><i style="width:' + ((done / total) * 100) + '%"></i></div></div>' +
        '<div class="dd-weeks">' + plan.map((w, wi) => {
          const wDone = w.items.filter((_, ii) => state[wi + '-' + ii]).length;
          return '<section class="dd-week"><header><div><small>' + esc(w.week) + '</small><br><b>' + esc(w.title) + '</b></div><span>' + wDone + '/' + w.items.length + '</span></header><ul class="dd-toggles">' +
            w.items.map((it, ii) => '<li><label><input type="checkbox" data-plan="' + wi + '-' + ii + '"' + (state[wi + '-' + ii] ? ' checked' : '') + '><i></i><span>' + esc(it) + '</span></label></li>').join('') + '</ul></section>';
        }).join('') + '</div>';
    };
    host.addEventListener('change', (event) => {
      const box = event.target.closest('[data-plan]');
      if (!box) return;
      state[box.dataset.plan] = box.checked;
      if (ctx.store) ctx.store.save();
      if (ctx.used) ctx.used();
      draw();
    });
    draw();
  };

  /* 12 · Test de perfil */
  TOOLS.sellerTest = (host, ctx) => {
    const answers = [];
    const keys = Object.keys(TEST.results);
    const draw = () => {
      const i = answers.length;
      if (i >= TEST.questions.length) return showResult();
      const q = TEST.questions[i];
      host.innerHTML = toolHead('¿Qué vendedor de Marketplace sos?', 'Respondé lo que hacés, no lo que deberías hacer.') +
        '<div class="dd-progress"><span>' + (i + 1) + ' / ' + TEST.questions.length + '</span><div class="dd-progress__bar"><i style="width:' + ((i / TEST.questions.length) * 100) + '%"></i></div></div>' +
        '<h4 style="margin:0;font-size:20px;font-weight:620;letter-spacing:-.03em;line-height:1.3">' + esc(q.q) + '</h4>' +
        '<div class="dd-options">' + q.a.map(([k, t]) => '<button type="button" class="dd-option" data-ans="' + k + '">' + esc(t) + '</button>').join('') + '</div>' +
        (i > 0 ? '<button type="button" class="dd-linkbtn" style="margin-top:14px" data-back>Volver</button>' : '');
    };
    const showResult = () => {
      const count = {};
      keys.forEach((k) => { count[k] = 0; });
      answers.forEach((a) => { count[a] += 1; });
      const top = keys.reduce((best, k) => (count[k] > count[best] ? k : best), keys[0]);
      const r = TEST.results[top];
      const rest = keys.filter((k) => k !== top);
      const second = rest.reduce((best, k) => (count[k] > count[best] ? k : best), rest[0]);
      const mods = r.mods.map((n) => ctx.unlocked
        ? '<a href="#modulo-' + n + '">Módulo ' + n + ' · ' + esc(MODULE_NAMES[n]) + '</a>'
        : '<span>Módulo ' + n + ' · ' + esc(MODULE_NAMES[n]) + '</span>').join('');
      host.innerHTML = '<div class="dd-result"><span class="dd-result__tag">Tu perfil dominante</span><h3>' + esc(r.name) + '</h3><p>' + esc(r.text) + '</p>' +
        (count[second] > 1 ? '<p style="font-size:13px;color:#777">Con rasgos de <b>' + esc(TEST.results[second].name) + '</b>.</p>' : '') +
        '<div class="dd-result__box"><b>Lo que lo resuelve</b><p>' + esc(r.fix) + '</p><div class="dd-result__mods">' + mods + '</div></div>' +
        '<div class="dd-result__box"><b>Tu primera victoria</b><p>' + esc(r.win) + '</p></div>' +
        '<div class="dd-result__actions">' + (ctx.unlocked ? '' : '<a class="dd-acad-btn dd-acad-btn--dark" href="#dd-acad-buy">Desbloquear mi plan completo</a>') +
        '<button type="button" class="dd-linkbtn" data-restart>Repetir el test</button></div></div>';
      if (ctx.onResult) ctx.onResult(top);
      if (ctx.used) ctx.used();
    };
    host.addEventListener('click', (event) => {
      if (event.target.closest('[data-restart]')) { answers.length = 0; draw(); return; }
      if (event.target.closest('[data-back]')) { answers.pop(); draw(); return; }
      const btn = event.target.closest('[data-ans]');
      if (!btn) return;
      answers.push(btn.dataset.ans);
      btn.classList.add('is-right');
      setTimeout(draw, reduceMotion() ? 0 : 180);
    });
    draw();
  };


  /* ==========================================================================
     LANDING (sin acceso)
     ========================================================================== */
  const storefrontRoot = () => {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.endsWith('/') ? root : root + '/';
  };

  const notifyThemeCart = (source, cart) => {
    const promise = Promise.resolve({ cart: { totalQuantity: Number(cart.item_count) || 0 }, detail: { itemCount: Number(cart.item_count) || 0, items: cart.items || [] } });
    const event = new Event('shopify:cart:lines-update', { bubbles: true });
    Object.defineProperties(event, { action: { value: 'update' }, context: { value: 'product' }, lines: { value: [] }, promise: { value: promise } });
    source.dispatchEvent(event);
  };

  const initLanding = (root, cfg) => {
    root.querySelectorAll('[data-dd-count-up]').forEach((el) => {
      const target = Number(el.dataset.ddCountUp) || 0;
      if (!target || reduceMotion()) return;
      const t0 = performance.now(), dur = 1400;
      const tick = (now) => { const k = Math.min(1, (now - t0) / dur); el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); };
      el.textContent = '0'; requestAnimationFrame(tick);
    });
    const ctx = { cfg: cfg, unlocked: false };
    const test = root.querySelector('[data-dd-acad-test]');
    if (test) TOOLS.sellerTest(test, ctx);
    const demo = root.querySelector('[data-dd-acad-demo-calc]');
    if (demo) TOOLS.priceCalc(demo, ctx);

    root.querySelectorAll('[data-dd-acad-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        const feedback = root.querySelector('[data-dd-acad-feedback]');
        button.disabled = true;
        try {
          const response = await fetch(storefrontRoot() + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'No se pudo agregar al carrito.');
          if (feedback) {
            feedback.hidden = false; feedback.classList.remove('is-error');
            feedback.innerHTML = '<span>Agregado al carrito</span><a href="' + storefrontRoot() + 'cart">Ver carrito</a>';
          }
          try {
            const cartResponse = await fetch(storefrontRoot() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
            if (cartResponse.ok) notifyThemeCart(button, await cartResponse.json());
          } catch (e) { /* el contador se sincroniza al abrir el carrito */ }
        } catch (error) {
          if (feedback) { feedback.hidden = false; feedback.classList.add('is-error'); feedback.textContent = error.message || 'No se pudo agregar. Intentá nuevamente.'; }
        } finally {
          button.disabled = false;
        }
      });
    });

    const trailerVideo = root.querySelector('[data-dd-acad-trailer]');
    const soundBtn = root.querySelector('[data-dd-acad-sound]');
    if (trailerVideo && soundBtn) {
      soundBtn.addEventListener('click', () => {
        trailerVideo.muted = !trailerVideo.muted;
        if (!trailerVideo.muted) { trailerVideo.currentTime = 0; trailerVideo.play().catch(() => {}); }
        soundBtn.textContent = trailerVideo.muted ? 'Activar sonido' : 'Silenciar';
      });
      trailerVideo.addEventListener('error', () => { const sec = trailerVideo.closest('.dd-acad-trailer'); if (sec) sec.hidden = true; });
    }

    const sticky = root.querySelector('[data-dd-acad-sticky]');
    const buy = root.querySelector('#dd-acad-buy');
    const hero = root.querySelector('.dd-acad-hero');
    if (sticky && buy && hero && 'IntersectionObserver' in window) {
      let heroVisible = true, buyVisible = false;
      const update = () => sticky.classList.toggle('is-visible', !heroVisible && !buyVisible);
      new IntersectionObserver((entries) => { entries.forEach((e) => { if (e.target === hero) heroVisible = e.isIntersecting; if (e.target === buy) buyVisible = e.isIntersecting; }); update(); }, { threshold: 0.05 }).observe(hero);
      new IntersectionObserver((entries) => { entries.forEach((e) => { buyVisible = e.isIntersecting; }); update(); }, { threshold: 0.05 }).observe(buy);
    }
  };

  /* ==========================================================================
     ACADEMIA (con acceso)
     ========================================================================== */
  const makeStore = (cfg) => {
    const key = 'dd-marketplace-v1-' + (cfg.customerId || 'guest');
    const base = { xp: 0, awards: {}, done: {}, pos: {}, plan: {}, exam: null, profile: null, started: null };
    const data = Object.assign(base, storage.get(key, {}));
    ['awards', 'done', 'pos', 'plan'].forEach((k) => { if (!data[k] || typeof data[k] !== 'object') data[k] = {}; });
    return {
      data: data,
      save() { storage.set(key, data); },
      award(id, xp) { if (data.awards[id]) return false; data.awards[id] = true; data.xp += xp; storage.set(key, data); return true; }
    };
  };

  const confetti = () => {
    if (reduceMotion()) return;
    for (let i = 0; i < 46; i += 1) {
      const piece = document.createElement('span');
      piece.className = 'dd-confetti';
      piece.style.left = Math.random() * 100 + 'vw';
      piece.style.background = THERMO_COLORS[i % 5] === '#f2c230' ? '#d9b56f' : THERMO_COLORS[i % 5];
      piece.style.setProperty('--dx', (Math.random() * 200 - 100) + 'px');
      piece.style.setProperty('--rot', (Math.random() * 900 + 200) + 'deg');
      piece.style.animationDuration = (Math.random() * 1.6 + 1.8) + 's';
      piece.style.animationDelay = (Math.random() * 0.3) + 's';
      document.body.appendChild(piece);
      setTimeout(() => piece.remove(), 4200);
    }
  };

  const initApp = (root, cfg) => {
    const app = root.querySelector('[data-dd-acad-app]');
    const contentNode = root.querySelector('[data-dd-acad-content]');
    let content;
    try { content = JSON.parse(contentNode.textContent); } catch (e) { app.innerHTML = '<p class="dd-acad-shell">No se pudo cargar el curso. Recargá la página.</p>'; return; }
    const modules = content.modules;
    let videos = {};
    try { videos = JSON.parse((root.querySelector('[data-dd-acad-videos]') || {}).textContent || '{}'); } catch (e) { videos = {}; }
    String(videos.links || '').split(/\n+/).forEach((line) => {
      const match = line.trim().match(/^(?:m(?:odulo)?\s*)?(\d{1,2})\s*[:=\-]\s*(https?:\/\/\S+)/i);
      if (match && videos['m' + Number(match[1])]) videos['m' + Number(match[1])].src = match[2];
    });
    modules.forEach((m) => {
      const v = videos[m.id];
      if (v && v.src && !m.steps.some((st) => st.type === 'video')) m.steps.unshift({ type: 'video', src: v.src, poster: v.poster });
    });
    const store = makeStore(cfg);
    if (!store.data.started) { store.data.started = new Date().toISOString(); store.save(); }

    const doneCount = () => modules.filter((m) => store.data.done[m.id]).length;
    const levelIndex = () => { const d = doneCount(); return d >= modules.length ? 4 : Math.min(3, Math.floor((d / modules.length) * 4)); };
    const nextModule = () => modules.findIndex((m) => !store.data.done[m.id]);

    const toolCtx = (key) => ({
      cfg: cfg, content: content, store: store, unlocked: true,
      used: () => store.award('tool-' + key, 15),
      onResult: (profile) => { store.data.profile = profile; store.save(); }
    });

    const scrollTop = () => {
      const top = root.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion() ? 'auto' : 'smooth' });
    };

    /* ---- Inicio ---- */
    const tabsHtml = (active) => {
      const ex = content.expert;
      if (!ex) return '';
      return '<nav class="dd-tabs-main" aria-label="Secciones del curso">' +
        '<a href="#inicio" class="' + (active === 'curso' ? 'is-active' : '') + '"' + (active === 'curso' ? ' aria-current="page"' : '') + '>Curso</a>' +
        '<a href="#experto" class="' + (active === 'experto' ? 'is-active' : '') + '"' + (active === 'experto' ? ' aria-current="page"' : '') + '><span class="dd-tabs-main__spark" aria-hidden="true">✦</span>Modo experto<em>' + ex.tips.length + '</em></a></nav>';
    };

    /* ---- Modo experto ---- */
    const renderExpert = () => {
      const ex = content.expert;
      if (!ex) { location.hash = '#inicio'; return; }
      if (!store.data.expert || typeof store.data.expert !== 'object') store.data.expert = {};
      const tried = store.data.expert;
      const cats = ['Todos'].concat(ex.tips.map((x) => x.cat).filter((c, i, a) => a.indexOf(c) === i));
      let filter = 'Todos';
      const draw = () => {
        const done = ex.tips.filter((_, i) => tried['t' + i]).length;
        const list = ex.tips.map((tip, i) => ({ tip, i })).filter((o) => filter === 'Todos' || o.tip.cat === filter);
        app.innerHTML = '<div class="dd-acad-shell dd-view">' + tabsHtml('experto') +
          '<section class="dd-expert-hero"><div><p class="dd-acad-eyebrow dd-acad-eyebrow--light"><span class="dd-acad-live"></span>' + esc(ex.title) + '</p>' +
          '<h1>Trucos para vender <em>más que el resto.</em></h1><p>' + esc(ex.intro) + '</p></div>' +
          '<div class="dd-expert-hero__count"><strong>' + done + '<small>/' + ex.tips.length + '</small></strong><span>trucos probados</span>' +
          '<div class="dd-progress__bar"><i style="width:' + Math.round((done / ex.tips.length) * 100) + '%"></i></div></div></section>' +
          '<div class="dd-chips dd-expert-filter">' + cats.map((c) => '<button type="button" class="dd-chip' + (c === filter ? ' is-on' : '') + '" data-ex-cat="' + esc(c) + '">' + esc(c) + '</button>').join('') + '</div>' +
          '<div class="dd-expert-list">' + list.map(({ tip, i }) => {
            const on = !!tried['t' + i];
            return '<details class="dd-expert' + (on ? ' is-done' : '') + '" style="--i:' + i + '">' +
              '<summary><span class="dd-expert__n">' + String(i + 1).padStart(2, '0') + '</span><span class="dd-expert__head"><small>' + esc(tip.cat) + ' · <b class="dd-expert__lvl dd-expert__lvl--' + esc(tip.level.toLowerCase()) + '">' + esc(tip.level) + '</b></small><b>' + esc(tip.title) + '</b></span><span class="dd-expert__chev" aria-hidden="true">+</span></summary>' +
              '<div class="dd-expert__body"><p>' + esc(tip.body) + '</p><ol>' + tip.steps.map((s) => '<li>' + esc(s) + '</li>').join('') + '</ol>' +
              (tip.caution ? '<div class="dd-expert__caution"><b>Ojo</b>' + esc(tip.caution) + '</div>' : '') +
              '<label class="dd-commit"><input type="checkbox" data-ex-try="' + i + '"' + (on ? ' checked' : '') + '> Ya lo probé</label></div></details>';
          }).join('') + '</div>' +
          '<p class="dd-tool__note" style="margin-top:24px">' + esc(ex.disclaimer) + '</p></div>';
      };
      app.onclick = (event) => {
        const c = event.target.closest('[data-ex-cat]');
        if (c) { filter = c.dataset.exCat; draw(); }
      };
      app.onchange = (event) => {
        const box = event.target.closest('[data-ex-try]');
        if (!box) return;
        tried['t' + box.dataset.exTry] = box.checked;
        store.save();
        if (box.checked) store.award('expert-' + box.dataset.exTry, 10);
        const det = box.closest('details');
        if (det) det.classList.toggle('is-done', box.checked);
        const done = ex.tips.filter((_, i) => tried['t' + i]).length;
        const strong = app.querySelector('.dd-expert-hero__count strong');
        if (strong) strong.innerHTML = done + '<small>/' + ex.tips.length + '</small>';
        const bar = app.querySelector('.dd-expert-hero__count .dd-progress__bar i');
        if (bar) bar.style.width = Math.round((done / ex.tips.length) * 100) + '%';
      };
      draw();
    };

    const renderHome = () => {
      const d = doneCount();
      const p = Math.round((d / modules.length) * 100);
      const lvl = levelIndex();
      const next = nextModule();
      const offset = 327 - (327 * p) / 100;
      const examReady = d === modules.length;
      const passed = store.data.exam && store.data.exam.passed;
      let cta;
      if (next === -1) cta = passed ? '<a class="dd-acad-btn dd-acad-btn--gold" href="#certificado">Ver mi certificado</a>' : '<a class="dd-acad-btn dd-acad-btn--gold" href="#examen">Rendir el examen final</a>';
      else cta = '<a class="dd-acad-btn dd-acad-btn--gold" href="#modulo-' + (next + 1) + '">' + (d === 0 ? 'Empezar el curso' : 'Continuar: Módulo ' + (next + 1)) + '</a>';
      const profile = store.data.profile && TEST.results[store.data.profile];

      app.innerHTML = '<div class="dd-acad-shell dd-view">' + tabsHtml('curso') +
        '<section class="dd-hello"><div><p class="dd-acad-eyebrow dd-acad-eyebrow--light"><span class="dd-acad-live"></span>' + esc(cfg.courseTitle) + '</p>' +
        '<h1>Hola, ' + esc(cfg.customerName) + '.</h1><p>' + d + ' de ' + modules.length + ' módulos · ' + nf0.format(store.data.xp) + ' XP' + (profile ? ' · Perfil: ' + esc(profile.name) : '') + '</p>' +
        '<div class="dd-hello__actions">' + cta + (d === 0 ? '<a class="dd-acad-btn dd-acad-btn--ghost" href="#herramienta-sellerTest">Hacer el test de perfil</a>' : '<a class="dd-acad-btn dd-acad-btn--ghost" href="#herramienta-priceCalc">Abrir calculadora</a>') + '</div></div>' +
        '<div class="dd-hello__ring" aria-label="' + p + '% completado"><svg viewBox="0 0 120 120"><circle cx="60" cy="60" r="52" class="dd-ring-bg"/><circle cx="60" cy="60" r="52" class="dd-ring-fg" style="stroke-dashoffset:327" data-ring="' + offset + '"/></svg><div><strong>' + p + '%</strong><small>completado</small></div></div></section>' +

        '<section class="dd-level"><div><small>Tu termómetro de aprendizaje</small><b>' + esc(LEVELS[lvl].name) + '</b><p>' + esc(LEVELS[lvl].hint) + '</p></div>' +
        thermo(lvl, LEVELS.map((l) => l.name)) + '</section>' +

        '<section class="dd-block"><div class="dd-block__head"><div><h2>Módulos</h2><p>Recomendado en orden, pero podés entrar a cualquiera.</p></div></div><div class="dd-mods">' +
        modules.map((m, i) => {
          const done = !!store.data.done[m.id];
          const pos = store.data.pos[m.id] || 0;
          const prog = done ? 100 : Math.round((pos / m.steps.length) * 100);
          const isNext = i === next;
          const status = done ? 'Completado' : isNext ? (pos > 0 ? 'Continuar' : 'Siguiente') : pos > 0 ? 'En curso' : m.minutes + ' min';
          return '<a class="dd-mod' + (done ? ' is-done' : '') + (isNext ? ' is-next' : '') + '" href="#modulo-' + (i + 1) + '">' +
            '<div class="dd-mod__top"><span class="dd-mod__n">' + String(i + 1).padStart(2, '0') + '</span><span class="dd-mod__status">' + status + '</span></div>' +
            '<div><small>' + esc(m.kicker) + '</small><b>' + esc(m.title) + '</b><div class="dd-mod__bar"><i style="width:' + prog + '%"></i></div></div></a>';
        }).join('') + '</div></section>' +

        '<section class="dd-block"><div class="dd-block__head"><div><h2>Caja de herramientas</h2><p>Usalas todos los días con tus publicaciones reales.</p></div></div><div class="dd-toolbox">' +
        Object.keys(TOOL_META).map((k) => '<a href="#herramienta-' + k + '"><span>' + esc(TOOL_META[k].icon) + '</span>' + esc(TOOL_META[k].name) + '</a>').join('') + '</div></section>' +

        (content.expert ? '<section class="dd-block"><a class="dd-expert-teaser" href="#experto"><span class="dd-expert-teaser__spark" aria-hidden="true">✦</span><div><small>Modo experto</small><b>' + content.expert.tips.length + ' trucos para vender más</b><p>Secretos de vendedor con experiencia, con pasos concretos para aplicar hoy.</p></div><span class="dd-acad-btn dd-acad-btn--gold">Entrar</span></a></section>' : '') +
        '<section class="dd-block"><div class="dd-final' + (examReady ? ' is-ready' : '') + '"><div><h3>' + (passed ? 'Certificado obtenido' : 'Examen final y certificado') + '</h3><p>' +
        (passed ? 'Aprobaste con ' + store.data.exam.score + ' de ' + content.exam.length + '. Descargalo cuando quieras.' : examReady ? content.exam.length + ' preguntas. Aprobás con ' + content.passScore + ' correctas.' : 'Se habilita al completar los ' + modules.length + ' módulos. Te faltan ' + (modules.length - d) + '.') + '</p></div>' +
        (passed ? '<a class="dd-acad-btn dd-acad-btn--gold" href="#certificado">Ver certificado</a>' : examReady ? '<a class="dd-acad-btn dd-acad-btn--gold" href="#examen">Rendir examen</a>' : '<span class="dd-acad-btn dd-acad-btn--outline is-disabled">Bloqueado</span>') +
        '</div></section></div>';

      requestAnimationFrame(() => requestAnimationFrame(() => {
        const r = app.querySelector('[data-ring]');
        if (r) r.style.strokeDashoffset = r.dataset.ring;
      }));
    };

    /* ---- Lección ---- */
    const renderLesson = (index) => {
      const m = modules[index];
      if (!m) { location.hash = '#inicio'; return; }
      let step = clamp(store.data.pos[m.id] || 0, 0, m.steps.length - 1);
      if (store.data.done[m.id]) step = 0;
      const answered = {};
      let cardCounter = 0;
      const cardNumbers = m.steps.map((s) => (s.type === 'card' ? ++cardCounter : 0));

      const draw = () => {
        const s = m.steps[step];
        store.data.pos[m.id] = Math.max(store.data.pos[m.id] || 0, step);
        store.save();
        const dots = m.steps.map((_, k) => '<i class="' + (k < step ? 'is-seen' : k === step ? 'is-current' : '') + '"></i>').join('');
        let body = '';
        if (s.type === 'video') {
          body = '<article class="dd-step dd-step--video"><span class="dd-step__kicker">Video del módulo</span>' +
            '<div class="dd-video"><video controls playsinline preload="metadata" src="' + esc(s.src) + '"' + (s.poster ? ' poster="' + esc(s.poster) + '"' : '') + ' data-dd-video></video></div>' +
            '<p class="dd-video__hint">Mirá el video y después seguí con las ideas clave.</p></article>';
        } else if (s.type === 'card') {
          store.award(m.id + '-c' + step, 5);
          body = '<article class="dd-step dd-step--card"><span class="dd-step__kicker">Idea ' + cardNumbers[step] + ' de ' + cardCounter + '</span><h2>' + esc(s.title) + '</h2><div class="dd-step__body">' + s.body + '</div>' +
            (s.tip ? '<aside class="dd-step__tip"><strong>Clave</strong>' + esc(s.tip) + '</aside>' : '') + '</article>';
        } else if (s.type === 'tool') {
          body = '<div class="dd-step dd-step--tool" data-tool-host></div>';
        } else if (s.type === 'quiz') {
          body = '<article class="dd-step dd-step--quiz"><span class="dd-step__kicker">Pregunta para fijar</span><h2>' + esc(s.q) + '</h2><div class="dd-options">' +
            s.options.map((o, k) => '<button type="button" class="dd-option" data-q="' + k + '">' + esc(o) + '</button>').join('') + '</div><div data-why></div></article>';
        } else if (s.type === 'action') {
          const isDone = !!store.data.done[m.id];
          body = '<article class="dd-step dd-step--action"><span class="dd-step__kicker">Tu acción de hoy</span><p class="dd-step__action">' + esc(s.text) + '</p>' +
            '<label class="dd-commit"><input type="checkbox" data-commit' + (isDone ? ' checked' : '') + '> Me comprometo a hacerlo</label>' +
            '<button type="button" class="dd-acad-btn dd-acad-btn--gold" data-complete' + (isDone ? '' : ' disabled') + '>' + (isDone ? 'Módulo completado ✓' : 'Completar módulo') + '</button></article>';
        }
        const isLast = step === m.steps.length - 1;
        const needsAnswer = s.type === 'quiz' && answered[step] == null;
        app.innerHTML = '<div class="dd-acad-shell"><div class="dd-lesson dd-view">' +
          '<div class="dd-lesson__top"><div class="dd-lesson__row"><a class="dd-back" href="#inicio">← Módulos</a><span class="dd-lesson__meta">Módulo ' + (index + 1) + ' de ' + modules.length + ' · ' + m.minutes + ' min</span></div><div class="dd-dots">' + dots + '</div></div>' +
          (step === 0 ? '<div class="dd-lesson__title" style="margin-bottom:22px"><small>' + esc(m.kicker) + '</small><h1>' + esc(m.title) + '</h1><p style="margin:10px 0 0;color:#666;font-size:15px">' + esc(m.outcome) + '</p></div>' : '') +
          body +
          '<div class="dd-lesson__nav"><button type="button" class="dd-acad-btn dd-acad-btn--outline dd-acad-btn--sm" data-prev' + (step === 0 ? ' disabled' : '') + '>Anterior</button><span>' + (step + 1) + ' / ' + m.steps.length + '</span>' +
          (isLast ? '<span style="width:96px"></span>' : '<button type="button" class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--sm" data-next' + (needsAnswer ? ' disabled' : '') + '>' + (s.type === 'tool' ? 'Seguir' : 'Siguiente') + '</button>') + '</div>' +
          '</div></div>';
        if (s.type === 'video') {
          const vid = app.querySelector('[data-dd-video]');
          if (vid) {
            vid.addEventListener('ended', () => store.award(m.id + '-video', 15));
            vid.addEventListener('error', () => {
              const wrap = vid.closest('.dd-video');
              if (wrap) wrap.outerHTML = '<div class="dd-video__missing">El video de este módulo todavía no está disponible. Podés seguir con las ideas clave.</div>';
            });
          }
        }
        if (s.type === 'tool') {
          const host = app.querySelector('[data-tool-host]');
          if (TOOLS[s.tool]) TOOLS[s.tool](host, toolCtx(s.tool));
        }
        if (s.type === 'quiz' && answered[step] != null) revealQuiz(s, answered[step]);
      };

      const revealQuiz = (s, pick) => {
        app.querySelectorAll('[data-q]').forEach((b) => {
          const k = Number(b.dataset.q);
          b.disabled = true;
          if (k === s.correct) b.classList.add('is-right');
          else if (k === pick) b.classList.add('is-wrong');
          else b.classList.add('is-dim');
        });
        const ok = pick === s.correct;
        app.querySelector('[data-why]').innerHTML = '<div class="dd-why"><b>' + (ok ? '¡Correcto! +20 XP' : 'No era esa.') + '</b>' + esc(s.why) + '</div>';
        const next = app.querySelector('[data-next]');
        if (next) next.disabled = false;
      };

      app.onclick = (event) => {
        if (event.target.closest('[data-prev]')) { step = Math.max(0, step - 1); draw(); scrollTop(); return; }
        if (event.target.closest('[data-next]')) { step = Math.min(m.steps.length - 1, step + 1); draw(); scrollTop(); return; }
        const q = event.target.closest('[data-q]');
        if (q && !q.disabled) {
          const s = m.steps[step];
          const pick = Number(q.dataset.q);
          answered[step] = pick;
          if (pick === s.correct) store.award(m.id + '-q' + step, 20);
          else store.award(m.id + '-q' + step, 0);
          revealQuiz(s, pick);
          return;
        }
        if (event.target.closest('[data-complete]')) completeModule(index);
      };
      app.onchange = (event) => {
        const commit = event.target.closest('[data-commit]');
        if (commit) { const btn = app.querySelector('[data-complete]'); if (btn && !store.data.done[m.id]) btn.disabled = !commit.checked; }
      };
      draw();
    };

    const completeModule = (index) => {
      const m = modules[index];
      const first = !store.data.done[m.id];
      store.data.done[m.id] = true;
      store.data.pos[m.id] = 0;
      store.save();
      if (first) store.award(m.id + '-done', 50);
      const d = doneCount();
      const all = d === modules.length;
      const nextIdx = nextModule();
      const overlay = document.createElement('div');
      overlay.className = 'dd-celebrate';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.innerHTML = '<div class="dd-celebrate__card"><div class="dd-celebrate__badge">✓</div>' + (first ? '<span class="dd-celebrate__xp">+50 XP</span>' : '') +
        '<h3>' + (all ? '¡Curso completo!' : 'Módulo ' + (index + 1) + ' completado') + '</h3>' +
        '<p>' + (all ? 'Llegaste a Vendedor Pro. Rendí el examen final y llevate tu certificado.' : d + ' de ' + modules.length + ' módulos. Tu termómetro: ' + esc(LEVELS[levelIndex()].name) + '.') + '</p>' +
        '<div class="dd-celebrate__actions">' +
        (all ? '<a class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--block" href="#examen" data-close>Rendir el examen</a>'
          : nextIdx !== -1 ? '<a class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--block" href="#modulo-' + (nextIdx + 1) + '" data-close>Siguiente: ' + esc(modules[nextIdx].title) + '</a>' : '') +
        '<a class="dd-acad-btn dd-acad-btn--outline dd-acad-btn--block" href="#inicio" data-close>Volver a los módulos</a></div></div>';
      root.appendChild(overlay);
      confetti();
      overlay.addEventListener('click', (event) => { if (event.target.closest('[data-close]') || event.target === overlay) overlay.remove(); });
      const focusable = overlay.querySelector('a');
      if (focusable) focusable.focus();
    };

    /* ---- Herramienta suelta ---- */
    const renderTool = (key) => {
      if (!TOOLS[key]) { location.hash = '#inicio'; return; }
      app.onclick = null; app.onchange = null;
      app.innerHTML = '<div class="dd-acad-shell"><div class="dd-lesson dd-view"><div class="dd-lesson__top"><div class="dd-lesson__row"><a class="dd-back" href="#inicio">← Inicio</a><span class="dd-lesson__meta">Caja de herramientas</span></div></div><div class="dd-step dd-step--tool" data-tool-host></div></div></div>';
      TOOLS[key](app.querySelector('[data-tool-host]'), toolCtx(key));
    };

    /* ---- Examen ---- */
    const renderExam = () => {
      app.onclick = null; app.onchange = null;
      if (doneCount() < modules.length) {
        app.innerHTML = '<div class="dd-acad-shell"><div class="dd-exam dd-view"><div class="dd-step"><h2>Todavía no</h2><p class="dd-step__body">El examen se habilita al completar los ' + modules.length + ' módulos.</p><a class="dd-acad-btn dd-acad-btn--dark" href="#inicio">Volver a los módulos</a></div></div></div>';
        return;
      }
      const qs = content.exam;
      let i = 0, right = 0, locked = false;
      const draw = () => {
        if (i >= qs.length) {
          const passed = right >= content.passScore;
          const prev = store.data.exam;
          if (passed && (!prev || !prev.passed || right > prev.score)) store.data.exam = { passed: true, score: right, date: (prev && prev.passed && prev.date) || new Date().toISOString() };
          else if (!passed && !(prev && prev.passed)) store.data.exam = { passed: false, score: right, date: null };
          store.save();
          if (passed) { store.award('exam-pass', 200); confetti(); }
          app.innerHTML = '<div class="dd-acad-shell"><div class="dd-exam dd-view"><div class="dd-step ' + (passed ? 'dd-step--action' : '') + '"><span class="dd-step__kicker">Resultado</span><h2>' + right + ' de ' + qs.length + '</h2>' +
            '<p class="dd-step__action" style="font-size:18px">' + (passed ? '¡Aprobaste! Tu certificado está listo.' : 'Necesitás ' + content.passScore + ' correctas. Repasá los módulos y volvé a intentarlo cuando quieras.') + '</p>' +
            '<div class="dd-hello__actions">' + (passed ? '<a class="dd-acad-btn dd-acad-btn--gold" href="#certificado">Ver mi certificado</a>' : '<button type="button" class="dd-acad-btn dd-acad-btn--dark" data-retry>Intentar de nuevo</button>') +
            '<a class="dd-acad-btn ' + (passed ? 'dd-acad-btn--ghost' : 'dd-acad-btn--outline') + '" href="#inicio">Volver al inicio</a></div></div></div></div>';
          return;
        }
        const q = qs[i];
        locked = false;
        app.innerHTML = '<div class="dd-acad-shell"><div class="dd-exam dd-view"><div class="dd-lesson__top"><div class="dd-lesson__row"><a class="dd-back" href="#inicio">← Salir</a><span class="dd-lesson__meta">Examen final · ' + (i + 1) + ' / ' + qs.length + '</span></div><div class="dd-dots">' + qs.map((_, k) => '<i class="' + (k < i ? 'is-seen' : k === i ? 'is-current' : '') + '"></i>').join('') + '</div></div>' +
          '<article class="dd-step dd-step--quiz"><span class="dd-step__kicker">Pregunta ' + (i + 1) + '</span><h2>' + esc(q.q) + '</h2><div class="dd-options">' + q.options.map((o, k) => '<button type="button" class="dd-option" data-eq="' + k + '">' + esc(o) + '</button>').join('') + '</div><div data-why></div></article></div></div>';
      };
      app.onclick = (event) => {
        if (event.target.closest('[data-retry]')) { i = 0; right = 0; draw(); scrollTop(); return; }
        if (event.target.closest('[data-exam-next]')) { i += 1; draw(); scrollTop(); return; }
        const b = event.target.closest('[data-eq]');
        if (!b || locked) return;
        locked = true;
        const q = qs[i];
        const pick = Number(b.dataset.eq);
        if (pick === q.correct) right += 1;
        app.querySelectorAll('[data-eq]').forEach((x) => {
          const k = Number(x.dataset.eq);
          x.disabled = true;
          if (k === q.correct) x.classList.add('is-right'); else if (k === pick) x.classList.add('is-wrong'); else x.classList.add('is-dim');
        });
        app.querySelector('[data-why]').innerHTML = '<div class="dd-why"><b>' + (pick === q.correct ? 'Correcto.' : 'Incorrecto.') + '</b>' + esc(q.why) + '</div><button type="button" class="dd-acad-btn dd-acad-btn--dark dd-acad-btn--sm" style="margin-top:16px" data-exam-next>' + (i + 1 < qs.length ? 'Siguiente' : 'Ver resultado') + '</button>';
      };
      draw();
    };

    /* ---- Certificado ---- */
    const renderCert = () => {
      app.onclick = null; app.onchange = null;
      const ex = store.data.exam;
      if (!ex || !ex.passed) { location.hash = doneCount() === modules.length ? '#examen' : '#inicio'; return; }
      const date = new Date(ex.date || Date.now());
      const dateText = date.toLocaleDateString('es-UY', { day: 'numeric', month: 'long', year: 'numeric' });
      const id = 'DDM-' + Number(cfg.customerId || 0).toString(36).toUpperCase() + '-' + date.getFullYear() + String(date.getMonth() + 1).padStart(2, '0');
      const name = cfg.customerFullName || cfg.customerName;
      app.innerHTML = '<div class="dd-acad-shell dd-view"><div class="dd-lesson__top" style="max-width:900px;margin-inline:auto"><div class="dd-lesson__row"><a class="dd-back" href="#inicio">← Inicio</a><span class="dd-lesson__meta">Certificado</span></div></div>' +
        '<div class="dd-cert-wrap"><div class="dd-cert"><div class="dd-cert__inner">' +
        '<div class="dd-cert__brand"><span>' + esc(cfg.brand || 'DeusDream') + ' · Academia</span><span>Certificado de finalización</span></div>' +
        '<div class="dd-cert__body"><small>Se certifica que</small><p class="dd-cert__name">' + esc(name) + '</p><p class="dd-cert__course">completó y aprobó el curso <em>' + esc(cfg.courseTitle) + '</em></p><small>10 módulos · Examen final ' + ex.score + '/' + content.exam.length + '</small></div>' +
        '<div class="dd-cert__foot"><div><b>' + esc(cfg.signature || 'Equipo DeusDream') + '</b>Firma</div><div><b>' + esc(dateText) + '</b>Fecha · ID ' + esc(id) + '</div><div class="dd-cert__seal">VENDEDOR<br>PRO</div></div>' +
        '</div></div>' +
        '<div class="dd-hello__actions"><button type="button" class="dd-acad-btn dd-acad-btn--dark" data-print>Descargar en PDF</button><a class="dd-acad-btn dd-acad-btn--outline" href="#inicio">Volver</a></div>' +
        '<p class="dd-tool__note">En la ventana de impresión elegí «Guardar como PDF» y orientación horizontal.</p></div></div>';
      app.querySelector('[data-print]').addEventListener('click', () => window.print());
    };

    /* ---- Router ---- */
    const route = (initial) => {
      const h = location.hash.replace('#', '');
      app.onclick = null; app.onchange = null;
      let m;
      if ((m = h.match(/^modulo-(\d+)$/))) renderLesson(Number(m[1]) - 1);
      else if ((m = h.match(/^herramienta-(\w+)$/))) renderTool(m[1]);
      else if (h === 'examen') renderExam();
      else if (h === 'certificado') renderCert();
      else if (h === 'experto') renderExpert();
      else renderHome();
      if (!initial) scrollTop();
    };
    window.addEventListener('hashchange', () => route(false));
    route(true);
  };

  /* ---------- Arranque ---------- */
  const boot = () => {
    document.querySelectorAll('[data-dd-marketplace]').forEach((root) => {
      if (root.dataset.ddReady) return;
      root.dataset.ddReady = 'true';
      let cfg = {};
      try { cfg = JSON.parse(root.querySelector('[data-dd-acad-config]').textContent); } catch (e) { cfg = {}; }
      if (root.dataset.state === 'unlocked') initApp(root, cfg);
      else initLanding(root, cfg);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
